import { render, staticRenderFns } from "./approval_setting.vue?vue&type=template&id=b022cb16"
import script from "./approval_setting.vue?vue&type=script&lang=js"
export * from "./approval_setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports